/*jslint browser: true*/
/*global $, jQuery, TrackUploader, Chart*/

'use strict';

// libs
import 'jquery';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap';

// old prototypes
import TrackUploader from 'TrackUploader';
import ChartService from 'Chart';

import { push } from 'react-router-redux'
import startTrackUploading from 'actions/particular/startTrackUploading';

export default function facade(store) {
  let chartService = null;

  $(document).on('importItem', function (e, form) {
    let dfd = $.Deferred();
    let FU = new TrackUploader(store);
    FU.Import(form, dfd);
    dfd.promise();

    dfd.then(() => {
      // TODO add item to redux flightsList
    });
  });

  $(document).on('uploadWithPreview', function (e, container, uploadingUid, recorderId, calibrationId) {
    let FU = new TrackUploader(store);
    FU.FillFactoryContaider($(container), uploadingUid, recorderId, calibrationId);
  });

  $(document).on('uploadPreviewedTrack', function() {
    let FU = new TrackUploader(store);
    FU.uploadPreviewed().then(() => {
      store.dispatch(push('/'));
    });
  });

  $(document).on('startProccessing', function (e, uploadingUid) {
    store.dispatch(startTrackUploading({
      uploadingUid: uploadingUid
    }));
  });

  $(document).on('endProccessing', function (e, uploadingUid, item) {
    store.dispatch({
      type: 'TRACK_UPLOADING_COMPLETE',
      payload: {
        uploadingUid: uploadingUid,
        item: item
      }
    });
  });

  $(document).on('chartShow', function (e, data) {
    chartService = new ChartService(store);
    chartService.SetChartData(data);
    chartService.FillFactoryContaider($(data.container));
  });

  $(document).on('toggleThreeDimIsShown', function () {
    if (chartService !== null) {
      chartService.threeDimIsShown = !chartService.threeDimIsShown;
      chartService.ResizeChart();
      chartService.PlotRedraw();
    }
  });
}
